import React, { useState } from 'react';
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import { compareSolutions, formatCurrency, getReferenceDisplayNameById, isValidSolutionType } from "../Script/RetailerFitGuide_Utils.js";
import RetailerFitGuide_FitTips from '../Shared/RetailerFitGuide_FitTips.jsx';
import { track_addToList } from '../Script/RetailerFitGuide_Tracking.js';
import { TRACK_EVENT_TYPE } from '../Script/RetailerFitGuide_Constants.js';
export const RetailerFitGuide_RefitResultItem = ({ solution }) => {
    const [expand, setExpand] = useState(false);
    const {
        selectedSolution,
        productList,
        setProductList,
        setNotificationMessage,
        translations
    } = useAppState();

    const getComparisonData = (solution) => {
        if (!isValidSolutionType(solution.solutionType) || solution.statusErp !== "Sellable" || !solution?.referenceinformation)
            return null;

        return compareSolutions(selectedSolution.SolutionComponents, solution.SolutionComponents);
    }

    const comparisonData = getComparisonData(solution);
    const reusedQuantity = comparisonData?.reusedProducts?.length;

    const addProductsToList = (products) => {

        let updatedList = [...productList]
        products.forEach((productListItem) => {
            const existing = updatedList.find(x => x.ProductId === productListItem.ProductId);
            if (existing)
                existing.Quantity += 1;
            else
                updatedList.push({ ...productListItem, Quantity: 1 })
        })
        track_addToList(products.map(x => x.ProductId), TRACK_EVENT_TYPE.REFIT);
        setProductList(updatedList);
        setNotificationMessage(translations.productAddedToList);
    }

    const getTotalPriceMissingProducts = () => {
        const totalPrice = comparisonData?.missingProducts?.reduce((total, product) => total + (product.RRP || 0), 0)
        return formatCurrency(totalPrice, _THULEDATA.retailerFitGuide?.currencyCode);
    }

    return <div className="retailerFitGuide_RefitResultItem"><button onClick={() => setExpand(!expand)} className="solutionButton">
        {solution.productImage?.ImageURL && <img src={solution.productImage.ImageURL} alt={solution.productImage.ImageAltText} />}
        <dl className="text-color--pitchBlack m-0 w-100 text-start">
            <dt className="heading5 text-color--gray80">{solution.dataProductWebtitle1}</dt>
            <dd className="paragraph mb-0">{solution.generationcalc === "Old" ? "(Old generation)" : solution.dataProductColorSpecification}</dd>
            <dd className='heading6 mb-0'>{translations.totalMsrp}: {getTotalPriceMissingProducts()}</dd>
            <dd className='text-color--gray80 paragraph--xs'> {translations.reusedParts}: <span className='solutionButton_highlight heading6'>{reusedQuantity}</span></dd>
        </dl>
        <i className={`le-icon-${expand ? "minus" : "plus"}`}></i>
    </button>
        {expand && <div><div className="mt-7">
            <div className="text-color--gray80 paragraph fst-italic mb-3">{translations.partsThatCanBeReused}:</div>
            <div className="refitResultItem_product">
                {comparisonData?.reusedProducts?.length > 0 ? comparisonData.reusedProducts.map((product, index) => <div className="refitResultItem_productItem" key={index}>
                    <div className="paragraph text-color--gray80">{getReferenceDisplayNameById(product.ReferenceTypeId)}</div>
                    <div className="d-flex justify-content-between">
                        <div className="heading5">{product.Webtitle1}</div>
                        <div className="heading5">{product.ErpOutdoor}</div>
                    </div>
                </div>) : <div className="heading5">{translations.requireFullNewRoofRackSystem}.</div>}
            </div>
        </div>
            <div>
                <div className="text-color--gray80 paragraph fst-italic mb-3">{translations.newPartsRequired}:</div>
                <div className="refitResultItem_product refitResultItem_product--new">
                    {comparisonData?.missingProducts?.length > 0 ? comparisonData.missingProducts.map((product, index) => <div className="refitResultItem_productItem" key={index}>
                        <div className="paragraph text-color--gray80 d-flex justify-content-between"><span>{getReferenceDisplayNameById(product.ReferenceTypeId)}</span><span>MSRP: {product.RRPDisplay}</span></div>
                        <div className="d-flex justify-content-between">
                            <div className="paragraph d-flex justify-content-between"><span>{product.Webtitle1}</span></div>
                            <div className="heading5">{product.ProductId}</div>
                        </div>
                    </div>) : <div className="heading5">-</div>}
                    {!solution && <div className="heading5">{translations.noRoofRackSystemFound}</div>}
                </div>

            </div>

            <RetailerFitGuide_FitTips journey={TRACK_EVENT_TYPE.REFIT} solution={solution} />
            <p className='paragraph mb-5'>{translations.totalMsrp}: {getTotalPriceMissingProducts()}</p>
            {comparisonData?.missingProducts?.length > 0 && <button onClick={() => addProductsToList(comparisonData.missingProducts)} className="btn thule-btn-default w-100 mb-7 d-flex align-items-center justify-content-center">{translations.addToList}</button>}
        </div>}
    </div>
}